import { SvgIcon, SvgIconProps, useTheme } from '@mui/material'
import { FC } from 'react'

export const GhostIcon: FC<SvgIconProps> = (props) => {
  const theme = useTheme()
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="primary"
      {...props}
    >
      <g id="vuesax/linear/ghost">
        <g id="ghost">
          <path
            id="Vector"
            d="M18.3327 17.613V11.038C18.3327 6.37135 14.5827 2.55469 9.99935 2.55469C5.41602 2.55469 1.66602 6.37135 1.66602 11.038V17.613C1.66602 18.663 2.291 18.9463 3.05767 18.2463L3.891 17.488C4.19933 17.2047 4.69936 17.2047 5.00769 17.488L6.67436 19.013C6.98269 19.2964 7.48266 19.2964 7.791 19.013L9.45766 17.488C9.766 17.2047 10.266 17.2047 10.5744 17.488L12.241 19.013C12.5494 19.2964 13.0494 19.2964 13.3577 19.013L15.0244 17.488C15.3327 17.2047 15.8327 17.2047 16.141 17.488L16.9743 18.2463C17.7077 18.9463 18.3327 18.663 18.3327 17.613Z"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
          />
          <path
            id="Vector_2"
            d="M6.66602 12.5547C8.64102 14.038 11.3577 14.038 13.3327 12.5547"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
          />
          <path
            id="Vector_3"
            d="M10.0007 10.0545C10.9211 10.0545 11.6673 9.30833 11.6673 8.38786C11.6673 7.46738 10.9211 6.72119 10.0007 6.72119C9.08018 6.72119 8.33398 7.46738 8.33398 8.38786C8.33398 9.30833 9.08018 10.0545 10.0007 10.0545Z"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
          />
        </g>
      </g>
    </SvgIcon>
  )
}
